module.exports = __webpack_public_path__ + "img/rented-stamp.d5e19c74.webp";